import React, { useCallback, useEffect, useState } from 'react'

import fetchFarmerFarmList from '../../apis/fetchFarmerFarmList'
import { Farm } from '../../models/farmer'
import FarmCard from './FarmCard'
import { ScrollView, StyleSheet, View } from 'react-native'
import { BG_STYLES, COMMON_STYLES } from '@dehaat/dds'
import EmptySectionCard from '../reusable/EmtySectionCard'

interface Props {
  selectedFarmId?: string
  farmerId: string
  onFarmSelect: (farm?: Farm) => void
}

const FarmList = ({ farmerId, selectedFarmId, onFarmSelect }: Props) => {
  const [farms, setFarms] = useState<Farm[]>([])

  const fetchAndUpdateFarmList = useCallback(async () => {
    const result = await fetchFarmerFarmList(farmerId)
    if (result) setFarms(result)
  }, [farmerId])

  useEffect(() => {
    fetchAndUpdateFarmList()
  }, [fetchAndUpdateFarmList])

  return (
    <View style={[COMMON_STYLES.p1, BG_STYLES.bgNeutral00, COMMON_STYLES.br1]}>
      {farms.length ? (
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          {farms.map((farm, index) => (
            <FarmCard
              farmIndex={index}
              farmImage={farm.photo}
              farmName={farm.name}
              land={''}
              latLng={''}
              reportUrl={null}
              cropImage={null}
              onSelect={() => onFarmSelect(farm)}
              isSelected={selectedFarmId === farm.id}
              onRemove={() => onFarmSelect(undefined)}
            />
          ))}
        </ScrollView>
      ) : (
        <EmptySectionCard
          title={'No tagged farm'}
          containerStyle={styles.emptyContainer}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  emptyContainer: {
    width: 260,
    minHeight: 250,
  },
})

export default FarmList
